import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { FormattedDate, injectIntl } from 'react-intl'
import { caseImagesSelector } from '../../../../redux/selectors'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import { Button, Grid } from '@material-ui/core'
import { goToImageView } from '../../../../redux/actions'
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import ImageWithLoading from '../../../../components/ImageWithLoading'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		width: '100%',
		backgroundColor: 'white',
		boxShadow: '0px 2px 10px #A6AFBF4',
		borderRadius: '5px 5px 0 0',
		height: 'auto',
		minHeight: '200px'
	},
	albumTitle: {
		color: 'black',
		fontSize: '16px',
		fontWeight: '800',
		textAlign: 'left',
		marginBottom: '12px'
	},
	albumNew: {
		color: '#02DC94',
		fontSize: '16px',
		fontWeight: '600',
		textAlign: 'left',
		marginBottom: '5px',
		"& > div:first-child": {
			marginRight: '7px'
		}
	},
	albumDate: {
		color: theme.palette.secondary.A600,
		fontSize: '16px',
		fontWeight: '400',
		textAlign: 'left',
	},
	albumCount: {
		color: theme.palette.secondary.A600,
		fontStyle: 'italic',
		fontSize: '14px',
		fontWeight: '400',
		textAlign: 'left',
		marginBottom: '5px', 
		"&:first-letter": {
			textTransform: 'capitalize'
		}
	},
	tooltipAlbumCount: {
		fontSize: '14px',
		"&:first-letter": {
			textTransform: 'capitalize'
		}		
	},
	imgThumb: {
		width: '100%',
		overflow: 'hidden',
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
		height: '225px',
		marginTop: 'auto',
		borderTop: '21px transparent solid',
		'& img': {
			display: 'block',
			width: '100%',
			height: 'auto',
			position: 'absolute',
			left: '50%',
			top: '50%',
			transform: 'translateX(-50%) translateY(-50%)',
			transition: 'all 0.3s ease',
		},
		'&:hover, &:focus': {
			'& img': {
				transform: 'scale(1.06) translateX(-50%) translateY(-50%)',
			},
			'& button': {
				backgroundColor: '#2045cd'
			}
		}
	},
	emptyThumb: {
		width: '100%',
		overflow: 'hidden',
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
		height: '225px',
		marginTop: 'auto',
		borderTop: '21px transparent solid',
		'& img': {
			display: 'block',
			width: '100%',
			height: 'auto',
			position: 'absolute',
			left: '50%',
			top: '50%',
			transform: 'translateX(-50%) translateY(-50%)',
			transition: 'all 0.3s ease',
		}
	}
}))

const ImageAlbums = ({ intl, caseImages, goToImages, imageId }) => {
	const classes = useStyles()

	const handleClick = (id) => {
		goToImages(id)
	}

	const showButton = (index) => {
		var button = document.getElementById(`zoomBtn-${index}`);
		if (button) {
			button.style.display = ""
		}
	}

	return (
		<>
		<Grid container spacing={3} className={classes.titleRoot}>
			<Grid item xs={12} style={{ paddingBottom: '0' }}>
				<Typography data-testid="case-albums-container-title" variant="h2"
					style={{
						fontSize: '22px',
						letterSpacing: '0.23px',
						fontWeight: '700',
						marginBottom: '5px'
					}}>
					{intl.formatMessage({ id: 'app.case.images.title' })}
				</Typography>
				<hr style={{ margin: '19px 0 18px 0', minWidth: '70px', width: '5vw', height: '2px', backgroundColor: 'black', borderWidth: 0 }} />
			</Grid>
		</Grid>

		<Grid container spacing={3}>
			{caseImages.albums
				.map((album, index) => {
					if (album.images && album.images.length > 0)
						return (<Grid item xs={12} sm={4} onClick={() => handleClick(album.id)} style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer', marginBottom: '30px' }} key={album.id}>
							{album.hasNew ?
								<div style={{ margin: '0 0 5px ' }}><span data-testid="new-score" style={{
									// backgroundColor: '#00a48a', 
									backgroundColor: '#007e6a',									
									color: '#fff', padding: '1px 6px 2px', fontWeight: 'bold', borderRadius: '4px', fontSize: '12px', textTransform: 'uppercase'
								}}>{intl.formatMessage({
									id: 'app.case.images.new'
								})}</span></div>
								: <br />}
							<Typography data-testid="case-album-title" variant='body1' className={classes.albumTitle} >
								{album.title}
							</Typography>

							<Typography data-testid="case-album-completed-date" variant='body1' className={classes.albumDate}>
								{ intl.formatMessage({ id: 'app.case.images.update' }) + ": " }
								<FormattedDate year='numeric' month='long' day='2-digit' value={album.lastCompletedDate} />
							</Typography>

							<Typography data-testid="case-album-images-count-title" variant='body1' className={classes.albumCount}>
								{intl.formatMessage({ id: 'app.case.images.multipleItemsTitle' }) + ": " }
								{album.images.length}
							</Typography>
							<div className={classes.imgThumb} >
								<ImageWithLoading src={album.images[0].smallThumbnailUrl ?? album.images[0].url} customOnLoad={() => showButton(index)} />
								<Tooltip title={<Typography className={classes.tooltipAlbumCount}>{intl.formatMessage({ id: 'app.case.images.multipleItemsTitle' })}: {album.images.length}</Typography>}  aria-label={`${intl.formatMessage({ id: 'app.case.images.multipleItemsTitle' })}` + ": " + `${album.images.length}`}>
									<Button id={`zoomBtn-${index}`} variant="contained" color="primary"
										aria-label="View images"
										style={{ maxHeight: '36px', maxWidth: '36px', minHeight: '36px', minWidth: '36px', position: 'absolute', top: '10px', right: '10px', display: 'none' }}>
										<PhotoLibraryIcon style={{ fontSize: '24px', color: 'white' }} />
									</Button>
								</Tooltip>
							</div>
						</Grid>)
					else
						return (
							<Grid item xs={12} sm={4} style={{ display: 'flex', flexDirection: 'column', marginBottom: '30px' }} key={album.id}>
								<br />
								<Typography data-testid="case-album-title" variant='body1' className={classes.albumTitle} >
									{album.title}
								</Typography>

								<Typography data-testid="case-album-completed-date" variant='body1' className={classes.albumDate}>
									<FormattedDate year='numeric' month='long' day='2-digit' value={album.firstDueDate} />
									{": " + intl.formatMessage({ id: 'app.case.images.anticipated' })}
								</Typography>

								<div className={classes.emptyThumb}>
								<img alt="Empty Album" src='/images/empty_album.svg' />
								</div>
							</Grid>)
				})
			}
		</Grid>
		</>
	)
}

const mapStateToProps = (state, ownProps) => ({
	caseImages: caseImagesSelector(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	goToImages: (albumId) => dispatch(goToImageView(albumId))
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(ImageAlbums)
